import { Props } from './Layout'
import { useProps as useGlobalNavigationHeaderProps } from '../GlobalNavigationHeader/useProps'
import { useProps as useGlobalNavigationMenuProps } from '../GlobalNavigationMenu/useProps'
import { ReactNode } from 'react'

export type Params = {
  children?: ReactNode
  activeMenu: Parameters<typeof useGlobalNavigationMenuProps>[0]['activeMenu']
  disabled?: boolean
}

export const useProps = ({ children, activeMenu, disabled }: Params): Props => {
  return {
    GlobalNavigationHeaderProps: useGlobalNavigationHeaderProps(),
    GlobalNavigationMenuProps: useGlobalNavigationMenuProps({ activeMenu, disabled }),
    children,
  }
}
